<template>
<div class="bb-ActivityDataAnalysis">
    <div class="bgc box-shadow ActivityleaderList-title">
        <div class="classes blod">{{eventname}}</div>
    </div>
    <div class="data-total">
        <div class="box box-shadow">
            <div class="box-detail">
                <div class="box-title">总浏览量(PV)</div>
                <div class="box-data"><span class="data">{{summary.viewcount}}</span></div>
            </div>
            <el-tooltip content="活动的全部浏览人次，同一个人多次访问算多次" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="box box-shadow">
            <div class="box-detail">
                <div class="box-title">总访问人数(UV)</div>
                <div class="box-data"><span class="data">{{summary.uviewcount}}</span></div>
            </div>
            <el-tooltip content="活动的浏览人数，同一个人多次访问算 1 次" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="box box-shadow">
            <div class="box-detail">
                <div class="box-title">总订单数</div>
                <div class="box-data"><span class="data">{{summary.totalordercount}}</span></div>
            </div>
            <el-tooltip content="活动的全部成交订单数" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
        <div class="box box-shadow">
            <div class="box-detail">
                <div class="box-title">总订单金额</div>
                <div class="box-data"><span class="data">￥{{summary.totalordermoney}}</span></div>
            </div>
            <el-tooltip content="通过普通链接和活动海报进入活动的次数" placement="top">
                <div>
                    <i class="tip el-icon-info"></i>
                </div>
            </el-tooltip>
        </div>
    </div>
    <div class="np-body">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="用户数据" name="userData">
                <userData ref="userData"></userData>
            </el-tab-pane>
            <el-tab-pane label="订单数据" name="orderData">
                <orderData ref="orderData"></orderData>
            </el-tab-pane>
            <el-tab-pane label="财务数据" name="financeData">
                <financeData ref="financeData"></financeData>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import UserData from 'views/brandBusiness/activityMgt/activity/components/userData.vue'
import OrderData from 'views/brandBusiness/activityMgt/activity/components/orderData.vue'
import FinanceData from 'views/brandBusiness/activityMgt/activity/components/financeData.vue'
import {getDataSummaryByEvent} from 'api/brandBusiness'
export default {
    name: 'DataAnalysis',
    data() {
        return {
            activeName: 'userData',
            eventname:  this.$route.query.eventname ? this.$route.query.eventname : '',
            summary: {
                totalordercount: 0,
                totalordermoney: '0.00',
                uviewcount: 0,
                viewcount: 0,
            },
            param: {
                eventinnerid:  this.$route.query.eventid ? this.$route.query.eventid : '',
            }
        }
    },
    mounted() {
        this._getDataSummaryByEvent()
    },
    methods: {
        handleClick() {
            switch (this.activeName) {
                case 'userData':
                    this.$refs.userData.getTotal(this.param)
                    break
                case 'orderData':
                    this.$nextTick(() => {
                        this.$refs.orderData.getTotal(this.param)
                    })
                    break
                case 'financeData':
                    this.$refs.financeData.getTotal(this.param)
                    break
            }
        },
        toggleTab() {
            this.$refs.userData.init = false
            this.$refs.orderData.init = false
            this.$refs.financeData.init = false
            this.$refs[this.activeName].getTotal(this.param)
        },
        _getDataSummaryByEvent() {
            getDataSummaryByEvent({
                data: this.param,
                success: data => {
                    this.summary = data.data
                    this.$refs.userData.getTotal(this.param)
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setParams'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        UserData, OrderData, FinanceData
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.bb-ActivityDataAnalysis {
    .ActivityleaderList-title {
        @include flexBox(space-between);
        height: 60px;
        padding: 0 20px;
        margin-bottom: 30px;
        .classes {
            margin-bottom: 0;
        }
        .el-input__icon {
            line-height: 1;
        }
    }
    .np-body{
        margin-top: 20px;
        .el-tabs--border-card{
            background: transparent;
        }
        .el-tabs__content{
            padding:0;
        }
        .el-tab-pane{
            display: block !important;
            height: auto;
            overflow-y: hidden;
        }
        .el-tab-pane[aria-hidden=true]{
            height: 0;
        }
        .left{
            border-right: 1px solid $line;
        }
    }
    .np-marketing-analysis{
        .total{
            height: 420px;
            display: flex;
            justify-content: flex-start;
            background: #fff;
            .left{
                padding: 0 10px;
                box-sizing: border-box;
                background: #fff;
                width: 240px;
                min-width: 240px;
                max-width: 240px;
                height: 100%;
                .outbox{
                    height: 50%;
                    padding-top:30px;
                    box-sizing: border-box;
                    .innerbox{
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        .box{
                            width: 50%;
                            height: 50px;
                            margin-bottom: 20px;
                            .name{
                                font-size: 12px;
                                margin-bottom: 10px;
                                display: flex;
                                align-items: center;
                                .tip{
                                    margin-left: 6px;
                                    display: inline-block;
                                    width: 12px;
                                    height: 12px;
                                }
                            }
                            .value{
                                font-size: 24px;
                            }
                        }
                    }
                }
                .outbox+.outbox{
                    border-top: 1px solid $line;
                }
            }
            .right{
                flex-grow: 1;
                overflow: hidden;
                .filters{
                    margin-bottom: 0 !important;
                    border-bottom: 1px solid $line;
                    padding: 20px 10px;
                    .add .el-button{
                        min-width: 48px;
                        font-size: 12px;
                    }
                    .search .el-button{
                        min-width: 72px;
                        font-size: 12px;
                    }
                    .dateInput{
                        margin-right: 10px;
                        width: 240px;
                        height: 36px;
                    }
                    .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
                        cursor: pointer;
                    }
                    .el-date-editor .el-range-separator{
                        line-height: 28px;
                    }
                }
                .echert{
                    margin: 10px;
                }
                .lineDatas{
                    background: $bgcolor-white;
                }
                .lineReport{
                    flex-grow: 1;
                }
            }
        }
        .list{
            margin-top: 20px;
            .result-list .el-table__row{
                height: auto;
            }
            .dateTime{
                height: 54px;
                line-height: 54px;
                background: #eee;
                color: #303133;
                font-size: 14px;
                padding: 0 15px;
            }
        }
    }
    .data-total{
        margin-top: 24px;
        @include flexBox(flex-start);
        .box{
            @include flexBox(flex-start);
            padding: 30px;
            height: 120px;
            width: 250px;
            box-sizing: border-box;
            flex-grow: 1;
            position: relative;
            background: #fff;
            .box-img{
                width: 60px;
                height: 60px;
                margin-right: 20px;
                margin-left: 30px;
            }
            .box-detail{
                flex-grow: 1;
            }
            .el-tooltip{
                position: absolute;
                width: 14px;
                height: 14px;
                top: 10px;
                right: 10px;
            }
        }
        .box+.box{
            margin-left: 40px;
        }
        .box:nth-child(1){
            border-right: 1px solid $line;
        }
    }
}
</style>
